import { SustenabilitySection } from "./SustenabilitySection";
import { OpenToShopersSection } from "./OpenToShopersSection";
import { BeginJourneySection } from "./BeginJourneySection";
import { TechnicalSection } from "./TechnicalSection";
import { CarrouselScreen } from "./CarrouselScreen";
import { WelcomeScreen } from "./WelcomeScreen";
import { FooterSection } from "./FooterSection";
import { TopBarMobile } from "./TopBar/Mobile";
import { TopBar } from "./TopBar";

import "./index.css";

export const PresentationPage = () => {
  const isMobile = window.innerWidth < 1000;

  return (
    <div className="p-presentation-page-holder">
      <div className="p-presentation-page">
        {!isMobile ? <TopBar /> : <TopBarMobile />}
        <WelcomeScreen />
        <CarrouselScreen />
        <OpenToShopersSection />
        <TechnicalSection />
        <SustenabilitySection />
        <BeginJourneySection />
        <FooterSection />
      </div>
    </div>
  );
};
